export default "__VITE_ASSET__DgvPb2j3__"